import React from 'react';
import { Card } from 'semantic-ui-react';
import ErrorLogsTable from '../../components/ErrorLogsTable';

const ErrorLog = () => {
  return (
    <div className='dashboard-container'>
      <Card fluid className='chart-card'>
        <Card.Content>
          <Card.Header className='header'>错误日志</Card.Header>
          <ErrorLogsTable />
        </Card.Content>
      </Card>
    </div>
  );
};

export default ErrorLog;
